import moment from "moment";
import React from "react";
import { statusImages } from "../../../resources/js/icons";
import P from "../../../shared/typography/P";

const FollowUpCard = (props) => {
    return (
        <div className="mb-2 pb-2.4 border-b border-blue-200">
            <div className="flex justify-between gap-1 mb-2">
                <P className="font-vietnam text-sm ">{props?.followupType}</P>
                <div className="flex items-center gap-0.5">
                    <img
                        src={statusImages[props?.proposalStage?.toLowerCase()]}
                        alt="fire"
                        className="h-2"
                    />
                    <P className="text-sm font-vietnam  capitalize">
                        {props?.proposalStage}
                    </P>
                </div>
            </div>

            <P className="text-xs  line-clamp-2 font-vietnam text-secondary">
                {props?.message}
            </P>

            {props?.actionTaken && (
                <P className="text-xs  line-clamp-2 font-vietnam text-secondary mt-2">
                    <span className="font-medium text-primary mr-1">
                        Action Taken:
                    </span>
                    {props.actionTaken}
                </P>
            )}

            <div className="flex items-center gap-1 mt-2">
                <P className="text-xs line-clamp-2 font-vietnam text-secondary">
                    {moment(props?.date * 1000).format("DD/MM/yyyy")}
                </P>
                <div className="w-0.8 h-0.8 bg-secondary rounded-full"></div>
                <P className="text-xs  line-clamp-2 font-vietnam text-secondary">
                    {moment(props?.date * 1000).format("hh:mm A")}
                </P>
            </div>
        </div>
    );
};

export default FollowUpCard;
